import React from 'react'
import {
    Box,
    BoxProps,
    Text,
    Switch,
    SwitchProps,
    TextProps,
} from '@chakra-ui/react'
import SharedLabel from './shared-label'
import SharedStack from '../wrappers/shared-stack'

export interface SharedSwitchProps extends SwitchProps {
    label?: string
    labelProps?: TextProps
    moreInfo?: React.ReactElement
    moreInfoTooltip?: React.ReactNode
    /** Rendered next to the label (e.g. enterprise field-link control). */
    labelActions?: React.ReactNode
    containerProps?: BoxProps
    showActiveLabel?: boolean
}

const SharedSwitch: React.FC<SharedSwitchProps> = ({
    label,
    labelProps,
    moreInfo,
    moreInfoTooltip,
    labelActions,
    containerProps,
    showActiveLabel = false,
    ...props
}) => {
    return (
        <Box {...containerProps}>
            {(label || moreInfo || labelActions) && (
                <Box>
                    <SharedStack row fit mb={1} align="center">
                        {label && (
                            <SharedLabel {...labelProps}>{label}</SharedLabel>
                        )}
                        {moreInfoTooltip && moreInfoTooltip}
                        {labelActions}
                    </SharedStack>
                    {!!moreInfo && moreInfo}
                </Box>
            )}
            <SharedStack row fit spacing={4}>
                {showActiveLabel && (
                    <Text fontSize="sm" fontWeight="semibold">
                        {props.isChecked ? 'Yes' : 'No'}
                    </Text>
                )}
                <Switch size="lg" colorScheme="brand" {...props} />
            </SharedStack>
        </Box>
    )
}

export default SharedSwitch
